<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M11.293 4.293a1 1 0 011.414 0l11 11a1 1 0 010 1.414l-11 11a1 1 0 01-1.414-1.414L21.586 16 11.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'arrowsChevronRightOutline'
}
</script>
